<template>
  <div class="number-chart" id="number-box" :style="{ height: HEIGHT + 'px' }">
    <div class="homepage-title">
      <el-tooltip class="item" placement="top" :open-delay="delay" popper-class="atooltip">
        <div slot="content">充电量=订单充电量总和<br />充电时长=订单充电时长总和<br/>订单数量=订单数量总和</div>
        <span class="title-n">充电统计</span>
      </el-tooltip>
      <div style="flex-grow: 3"></div>
      <div class="right-btn">
        <span :class="[active == 1 ? 'active' : '']" @click="dateClick(1)"
          >日</span
        >
        <span>/</span>
        <span :class="[active == 2 ? 'active' : '']" @click="dateClick(2)"
          >月</span
        >
      </div>
    </div>
    <div style="width: 100%; height: 100%" id="number-echarts"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import { type } from "os";
export default {
  data() {
    return {
      delay:1000,
      HEIGHT: "",
      width: "",
      active: 1,
      list: {
        day: [],
        month: [],
      },
    };
  },
  mounted() {
    let o = document.getElementById("number-box");
    this.width = o.clientWidth || o.offsetWidth;
    // debugger
    // this.HEIGHT = this.width/1.438;
    this.HEIGHT = this.width / 1.63847;
    this.$nextTick(function () {
      if (localStorage.getItem("token")) {
        this.getEchartData();
      }
      // this.getEchartData();
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.timer1);
  },
  destroyed() {
    window.onresize = null;
  },
  computed: {
    isChangeMsg() {
      return this.$store.state.collapse;
    },
  },
  watch: {
    isChangeMsg(val) {
      let echart = echarts.init(document.getElementById("number-echarts"));
      clearInterval(this.timer1);
      this.timer1 = setInterval(() => {
        setTimeout(function () {
          echart.resize();
        }, 0);
      }, 100);
    },
  },
  methods: {
    getEchartData(data) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getDayMonthChargingStatistics",
      };
      this.$api({
        method: "post",
        url: "/api.php/Overview/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          this.$store.commit("getDayMonthChargingStatistics", su);
          if (su.data.code == 1) {
            this.list = su.data.list;
            // this.list = this.list;
            // console.log(this.list);
            this.drawChart(this.list.day);
          } else if (su.data.code == 0) {
            this.$message.error("数据库操作失败");
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            // this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    calMax(arr) {
      // console.log(arr);
      // debugger
      for (let j in arr) {
        arr[j] = Number(arr[j]);
      }
      var max = arr[0];
      for (var i = 1; i < arr.length; i++) {
        // 求出一组数组中的最大值
        if (max < arr[i]) {
          max = arr[i];
        }
      }
      var maxint = Math.ceil(max / 10); // 向上取整
      // console.log(maxint);
      var maxval = maxint * 10; // 最终设置的最大值
      // console.log(maxval);
      return maxval; // 输出最大值
    },
    calMaxTow(arr1, arr2) {
      for (let j in arr1) {
        arr1[j] = Number(arr1[j]);
      }
      for (let j in arr2) {
        arr2[j] = Number(arr2[j]);
      }
      var max1 = arr1[0];
      for (var i = 1; i < arr1.length; i++) {
        // 求出一组数组中的最大值
        if (max1 < arr1[i]) {
          max1 = arr1[i];
        }
      }
      var max2 = arr2[0];
      for (var i = 1; i < arr2.length; i++) {
        // 求出一组数组中的最大值
        if (max2 < arr2[i]) {
          max2 = arr2[i];
        }
      }
      let max = 0;
      if (max1 > max2) {
        max = max1;
      } else {
        max = max2;
      }
      var maxint = Math.ceil(max / 10); // 向上取整
      var maxval = maxint * 10; // 最终设置的最大值
      return maxval; // 输出最大值
    },
    drawChart(data) {
      clearInterval(this.timer);
      clearInterval(this.timer1);
      var series = JSON.parse(JSON.stringify(data));
      var legendData = []; //订单数量
      var date = [];
      var charge_power = []; //充电量
      var charge_time = []; //充电时长
      for (let i = 0; i < series.length; i++) {
        legendData.push(series[i].batch_num);
        date.push(series[i].date);
        charge_power.push(series[i].charge_power);
        charge_time.push(series[i].charge_time);
      }

      var maxappreg = this.calMax(charge_power); //充电量
      var maxactive = this.calMaxTow(charge_time, legendData); //充电时长  订单数量
      var interval_left = Math.ceil(maxappreg / 5); //左轴间隔
      var interval_right = Math.ceil(maxactive / 5); //右轴间隔

      let echart = echarts.init(document.getElementById("number-echarts"));
      var option = {
        color: ["#60C7FF", "#FD1C54", "#00CD56"],
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left",
          },
          formatter: (arr) => {
            //自定义提示信息
            // console.log(arr);
            // return
            let txtCon = "";
            if (arr.length != 0) {
              txtCon += arr[0].axisValue + "<br/>";
            }
            for (let i in arr) {
              if (arr[i].seriesName == "充电量") {
                txtCon +=
                  arr[i].marker +
                  "充电量" +
                  " : " +
                  arr[i].data +
                  " 度" +
                  "<br/>";
              } else if (arr[i].seriesName == "充电时长") {
                txtCon +=
                  arr[i].marker +
                  "充电时长" +
                  " : " +
                  arr[i].data +
                  " 小时" +
                  "<br/>";
              } else if (arr[i].seriesName == "订单数量") {
                txtCon +=
                  arr[i].marker +
                  "订单数量" +
                  " : " +
                  arr[i].data +
                  " 个" +
                  "<br/>";
              }
            }
            return txtCon;
          },
        },
        legend: {
          // orient: 'vertical',
          bottom: this.width > 340 ? 8 : 0,
          textStyle: { color: "#FFFDFE" },
          left: "center",
          itemWidth: 15, // 图例图形宽度
          itemHeight: 8,
          // itemGap: 10,
          itemGap: 0, //图例左右距离
          data: [
            {
              name: "充电量",
              // icon: "circle",
              textStyle: {
                fontSize: "12px",
              },
            },
            {
              name: "充电时长",
              // icon: "arrow",
              textStyle: {
                fontSize: "12px",
              },
            },
            {
              name: "订单数量",
              // icon: "pin",
              textStyle: {
                fontSize: "12px",
              },
            },
          ],
        },
        grid: {
          containLabel: true,
          top: "22%", //距上边距
          bottom: this.width > 340 ? "10%" : "9%", //距离下边距
          right: "5%",
          left: this.width > 340 ? "1%" : "1%",
        },
        xAxis: {
          type: "category",
          data: date,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
            rotate: 60,
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#61CBFD", //更改坐标轴文字颜色
                fontSize: 10, //更改坐标轴文字大小
              },
            },
            min: 0,
            max: maxappreg,
            splitNumber: 5,
            interval: interval_left,
            axisLine: {
              lineStyle: {
                color: "#07253F", //更改坐标轴颜色
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#07253F"],
              },
            },
          },
          {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#61CBFD", //更改坐标轴文字颜色
                fontSize: 10, //更改坐标轴文字大小
              },
            },
            min: 0,
            max: maxactive,
            splitNumber: 5,
            interval: interval_right,
            axisLine: {
              lineStyle: {
                color: "#07253F", //更改坐标轴颜色
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#07253F"],
              },
            },
          },
        ],
        series: [
          {
            name: "充电量",
            type: "bar",
            barWidth: 18, //柱图宽度
            data: charge_power,
            yAxisIndex: 0,
          },
          {
            name: "充电时长",
            data: charge_time,
            type: "line",
            symbol: "circle",
            yAxisIndex: 1,
          },
          {
            name: "订单数量",
            data: legendData,
            type: "line",
            symbol: "circle",
            yAxisIndex: 1,
          },
        ],
      };
      echart.setOption(option);
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        setTimeout(function () {
          window.onresize = function () {
            echart.resize();
          };
        }, 0);
      }, 100);
    },
    dateClick(num) {
      // debugger
      this.active = num;
      // this.getEchartData(this.active);
      if (this.active == 1) {
        this.drawChart(this.list.day);
      } else if (this.active == 2) {
        this.drawChart(this.list.month);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.number-chart {
  width: calc(100% - 14px);
  // height: 290px;
  // height: 20%;
  background: url(../../assets/img/Frame.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
  // margin-bottom: 16px;
  padding-left: 14px;
  overflow: hidden;
  .homepage-title {
    width: 70%;
    display: flex;
    left: 26px;
    .title-n {
      color: #fffffd;
      flex-grow: 1;
      z-index: 999;
    }
  }
  .right-btn {
    display: inline-block;
    flex-grow: 1;
    z-index: 999;
    span {
      color: #006EAE;
      cursor: pointer;
    }
    span.active {
      color: #ABE3FE;
    }
  }
  canvas {
    left: 12px !important;
  }
}
@media screen and (max-width: 1500px) {
  .number-chart {
    .homepage-title {
      font-size: 12px;
      top: 7px;
      left: 17px;
    }
  }
}
</style>
<style>
.atooltip {
  background:rgba(50,50,50,0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/numberChart.vue